import { tss } from 'tss-react/mui';

export const useSimpleVoiceAssistantStyles = tss.create(() => ({
  '@keyframes slideUp': {
    from: { opacity: 0, transform: 'translateY(10px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  slideUp: {
    animation: '$slideUp 0.3s ease-out forwards',
  },
  connectedContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
  },
  transcriptionContainer: {
    flex: 1,
    width: '100%',
    backgroundColor: '#fafbfc',
    overflow: 'hidden',
    minHeight: '380px',
    borderBottom: '1px solid #f3f4f6',
  },
  controlBarContainer: {
    width: '100%',
    backgroundColor: '#ffffff',
  },
}));
